<template>
  <div :style="`${'height: 100%; background-color: '+backgroundColor}`">
    <div class="cmp-handle" style="z-index:999">
      <el-dropdown>
        <span class="el-dropdown-link">
          <i class="el-input__icon el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="settingVisible=true"
                            style="text-align: center">设置
          </el-dropdown-item>
          <el-dropdown-item @click.native="editSignalName"
                            style="text-align: center">重命名
          </el-dropdown-item>
          <el-dropdown-item @click.native="select()"
                            style="text-align: center">{{selcted ? '取消选中' : '选中'}}
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleCmp('delete',componentIndex)"
                            style="text-align: center">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-tooltip :content="uDataSources.text" placement="top-start" :open-delay="1000">
      <p @dblclick="(event)=>dbClick(event,uDataSources.key)"
         v-show="!edit" :style="`${'cursor: pointer; font-size: '+fontSize +'px;color: '+fontColor}`">{{uDataSources.text}}</p>
    </el-tooltip>
    <el-input v-if="edit" v-model="uDataSources.text" size="mini" @keyup.enter.native="saveControlName">
    </el-input>
    <a>
      <div v-if="isTrigger"
           @drop="(event) => dragToSubmitCmp(event, componentIndex)"
           @dragover="allowSignalMeasureDrop">
        <el-input-number :size="size" controls-position="right" style="width: 90%"
                         @blur="saveControlMsg" @change="saveControlMsg"
                         v-model="uDataSources.value" @keyup.enter.native="sendTrigger"
                         :min="0" :max="1">
        </el-input-number>
      </div>
      <div v-else
           @dblclick="dbClickSetting"
           @click="(event)=>clickSelect(event)"
           @drop="(event) => dragToSubmitCmp(event, componentIndex)"
           @dragover="allowSignalMeasureDrop">
        <div style="width: 90%"
             @dblclick="(event)=>stopdbClick(event)">
          <el-input-number :size="size" v-model="uDataSources.value" :step="step"
                           :min="rangeList.min" :max="rangeList.max"
                           style="width: 100%;"
                           @blur="saveControlMsg" @change="saveControlMsg"
                           @keyup.enter.native="saveControlMsg" controls-position="right">
          </el-input-number>
        </div>
      </div>
    </a>
    <el-dialog
        :append-to-body="true"
        :visible.sync="settingVisible"
        title="设置"
        width="30%">
      <el-row>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">字体大小</span>
          <el-input-number size="mini" v-model="exampleFontSize" :min="12" :max="30" controls-position="right" style="width: 80%"></el-input-number>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">颜色</span>
          <el-color-picker size="mini" v-model="exampleFontColor" show-alpha></el-color-picker>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">预览</span>
          <span :style="`${'font-size: '+exampleFontSize +'px;color: '+exampleFontColor}`">信号名</span>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">输入框大小</span>
          <el-select v-model="exampleSize" placeholder="请选择" style="width: 80%" size="small">
            <el-option
                v-for="item in sizeOptions"
                :key="item.label"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">步长</span>
          <el-input-number size="small" v-model="exampleStep" controls-position="right" style="width: 80%"></el-input-number>
        </el-col>
        <el-col :span="8">
          <span style="font-size: 16px;display: block">预览</span>
          <el-input-number :size="exampleSize" :step="step" v-model="exampleValue" controls-position="right" style="width: 80%"></el-input-number>
        </el-col>
      </el-row>
      <span class="dialog-footer" slot="footer">
        <el-button @click="settingVisible = false">取 消</el-button>
        <el-button @click="settingVisible = false,saveControlConfig()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { PROJECT_NODE_TYPE } from '@/common/enums';
import projectDetailAPI from '@/api/projectDetail';

export default {
  name: 'NumericControl',
  props: {
    componentIndex: {
      type: Number,
    },
    itemData: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      edit: false,
      settingVisible: false,
      exampleValue: 100,
      size: 'mini',
      exampleSize: 'mini',
      fontColor: '#303133',
      exampleFontColor: '#303133',
      fontSize: 15,
      exampleFontSize: 15,
      step: 1,
      exampleStep: 1,
      uDataSources: {
        text: '信号名',
        key: '',
        value: 0,
      },
      sizeOptions: [
        { label: 'Large', value: '' },
        { label: 'Medium', value: 'medium' },
        { label: 'Small', value: 'small' },
        { label: 'Mini', value: 'mini' },
      ],
    };
  },
  methods: {
    ...mapActions('Engineering', ['deleteCpt']),
    ...mapMutations('Engineering', ['addSubmitCmp', 'setAnchorKeyWord', 'setAnchorPointId', 'setCmpSyncKey', 'selectCpt']),
    handleCmp(command, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          break;
        default:
          break;
      }
    },
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
    allowSignalMeasureDrop(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL
        || this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_CHARACTER
        || this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_TRIGGER) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    dragToSubmitCmp(event, componentIndex) {
      // if (this.getCurCmpStatus) {
      //   this.$message({
      //     message: '当前面板正在运行，请先进行关闭',
      //   });
      //   return;
      // }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      const { id, dtype, text } = dragNode;
      this.addSubmitCmp({
        id, dtype, text, componentIndex,
      });
    },
    editSignalName() {
      if (this.uDataSources.key !== '') {
        this.edit = true;
      } else {
        this.$message({
          message: '请先绑定信号！',
          type: 'warning',
        });
      }
    },
    async saveControlMsg() {
      const projectId = this.$store.state.Engineering.projectId;
      const signalId = this.uDataSources.key;
      const value = this.uDataSources.value;
      await projectDetailAPI.saveControlMsg(projectId, signalId, value)
        .then(() => {
          this.setCmpSyncKey();
        });
    },
    async sendTrigger() {
      const projectId = this.$store.state.Engineering.projectId;
      const triggerId = this.uDataSources.key;
      await projectDetailAPI.sendTrigger(projectId, triggerId);
    },
    async getControlMsg() {
      const projectId = this.$store.state.Engineering.projectId;
      const signalId = this.uDataSources.key;
      await projectDetailAPI.getControlMsg(projectId, signalId)
        .then((res) => {
          console.log('control获取值');
          console.log(res);
          this.uDataSources.value = res.value;
        });
    },
    async saveControlConfig() {
      this.size = this.exampleSize;
      this.step = this.exampleStep;
      this.fontSize = this.exampleFontSize;
      this.fontColor = this.exampleFontColor;
      const projectId = this.$store.state.Engineering.projectId;
      const panelId = this.$store.state.Engineering.panelId;
      const componentStyleParams = [];
      const componentStyleParam = {
        componentId: this.itemData.cid,
        wordSize: this.fontSize,
        wordColor: this.fontColor,
        componentSize: this.size,
        step: this.step,
      };
      componentStyleParams.push(componentStyleParam);
      console.log({ projectId, panelId, componentStyleParams });
      await projectDetailAPI.saveCptStyle(projectId, panelId, componentStyleParams)
        .catch((err) => {
          this.$message.error('保存失败！');
        });
    },
    select() {
      const id = this.itemData.cid;
      this.selectCpt(id);
    },
    async saveControlName() {
      this.edit = false;
      const projectId = this.$store.state.Engineering.projectId;
      const panelId = this.$store.state.Engineering.panelId;
      const componentId = this.itemData.cid;
      const signalKey = this.uDataSources.key;
      const name = this.uDataSources.text;
      console.log({ projectId, panelId, componentId, signalKey, name });
      await projectDetailAPI.saveCptName(projectId, panelId, componentId, signalKey, name)
        .catch((err) => {
          this.$message.error('信号名保存失败！');
        });
    },
    clickSelect(event) {
      if (event.ctrlKey) {
        this.select();
      }
    },
    dbClickSetting() {
      this.settingVisible = true;
    },
    stopdbClick(event) {
      event.stopPropagation();
    },
  },
  mounted() {
    if (this.uDataSources.key !== '') {
      if (!this.isTrigger) {
        this.getControlMsg();
      }
    }
  },
  computed: {
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    ...mapState('Engineering', ['dragTreeNodeType']),
    dataSou() {
      return this.itemData.dataSources || [];
    },
    styleSetting() {
      return this.itemData.styleSetting || [];
    },
    // 触发器组件逻辑待删除
    isTrigger() {
      if (this.uDataSources.key.indexOf('#TRIGGER') > -1) {
        return true;
      }
      return false;
    },
    selcted() {
      const id = this.itemData.cid;
      if (this.$store.state.Engineering.selectedCpts.indexOf(id) > -1) {
        return true;
      }
      return false;
    },
    syncKey() {
      return this.$store.state.Engineering.controlSyncKey;
    },
    rangeList() {
      const range = { min: -Infinity, max: Infinity };
      if (this.uDataSources.key !== '') {
        const key = this.uDataSources.key;
        const leftTree = this.$store.state.Engineering.leftStructure;
        for (const i in leftTree) {
          for (const j in leftTree[i].children) {
            for (const k in leftTree[i].children[j].children) {
              for (const m in leftTree[i].children[j].children[k].children) {
                for (const l in leftTree[i].children[j].children[k].children[m].children) {
                  if (key === leftTree[i].children[j].children[k].children[m].children[l].id) {
                    range.min = leftTree[i].children[j].children[k].children[m].children[l].min;
                    range.max = leftTree[i].children[j].children[k].children[m].children[l].max;
                  }
                }
              }
            }
          }
        }
        return range;
      }
      return range;
    },
    // styleKey() {
    //   return this.$store.state.Engineering.styleKey;
    // },
    backgroundColor() {
      if (this.selcted) {
        return 'rgba(127,204,232,0.21)';
      }
      return '';
    },
  },
  watch: {
    dataSou: {
      handler(newDataSou) {
        const self = this;
        if (newDataSou.length > 0) {
          self.uDataSources.text = newDataSou[0].text;
          self.uDataSources.key = newDataSou[0].key;
        }
      },
      deep: true,
      immediate: true,
    },
    // 由0改为setting.length-1，待优化
    styleSetting: {
      handler(setting) {
        const self = this;
        if (setting.length > 0) {
          self.size = setting[setting.length - 1].size;
          self.step = setting[setting.length - 1].step;
          self.fontSize = setting[setting.length - 1].fontSize;
          self.fontColor = setting[setting.length - 1].fontColor;
        }
      },
      deep: true,
      immediate: true,
    },
    syncKey() {
      const keyList = this.$store.state.Engineering.controlSyncKeyList;
      const key = this.uDataSources.key;
      if (keyList.indexOf(key) > -1) {
        this.getControlMsg();
      }
    },
    // 待删除
    // styleKey() {
    //   if (this.itemData.setting !== undefined) {
    //     this.size = this.itemData.setting.size;
    //     this.step = this.itemData.setting.step;
    //     this.fontSize = this.itemData.setting.fontSize;
    //     this.fontColor = this.itemData.setting.fontColor;
    //   }
    //   if (this.itemData.signalName !== undefined) {
    //     this.uDataSources.text = this.itemData.signalName;
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
  .el-input__icon {
    line-height: 25px;
    opacity:0;
  }
  .cmp-handle {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/engineering/NumericControl.vue